import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PopUpContainer from 'src/components/common/modal/PopUp';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { Typography } from 'src/components/common/Typography';
import { icons } from 'src/configs/icons';
import styles from './styles.module.scss';

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};

const OpenSafeErrorPopup: FC<IProps> = ({ isOpen, onClose }) => {
  const { t }: Translation = useTranslation();

  return (
    <PopUpContainer
      title={t('safe_promo.open_safe_error_popup_title')}
      isOpen={isOpen}
      handleClose={onClose}
      hasOverlay
      zIndex={250}
    >
      <div className={styles.popup_body}>
        <SvgIcon src={icons.errorIcon} size="xxxl" />
        <Typography variant={'h4'} color="textPrimary">
          {t('safe_promo.open_safe_error_popup_description')}
        </Typography>
      </div>
    </PopUpContainer>
  );
};

export default OpenSafeErrorPopup;
